import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { environment } from 'src/environments/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class tarjetasCreditoActualizadas extends BaseService{
    recordName = 'cdr';

    url = `${ environment.host }/tarjetas-credito-actualizadas`;

    async getTarjetasCreditoActualizadas( filtros: Record< string, any > ) {
        try {
            await this.updateToken();            
            // this.header['filters'] = JSON.stringify(await this.getAdicionalFilters());
            let url = `${ environment.host }/cabal/get-tarjetas-credito-actualizadas`;
            const resp = await lastValueFrom( this.http.post<any>(`${url}`,{ filtros}, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async getTarjetasActualizadas( filtros: Record< string, any > ){
        try {
            await this.updateToken();
            // this.header['filters'] = JSON.stringify(await this.getAdicionalFilters());
            let url = `${this.url}/get-tarjetas`;
            const resp = await lastValueFrom( this.http.post<any>(`${url}`, { filtros },{ headers: this.header }) );
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }
}
